export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Categories", href: "#categories" },
  { label: "Franchise", href: "/franchise" },
  { label: "FAQ", href: "/faq" },
  { label: "Contact", href: "#contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  overview: "https://customer-assets.emergentagent.com/job_discount-retail-hub-1/artifacts/5zvll9cf_baadc4a0-ed7f-4236-8dfe-aa75d5b9aaa6.png",
  family: "https://customer-assets.emergentagent.com/job_discount-retail-hub-1/artifacts/7qugo008_7222f739-4d03-4f2e-99d7-42c8f46121a8.png",
  business: "https://customer-assets.emergentagent.com/job_discount-retail-hub-1/artifacts/ilsxxhdq_357d8e13-87af-43be-b747-8421496141f3%20%281%29.png",
  franchise: "https://customer-assets.emergentagent.com/job_discount-retail-hub-1/artifacts/rbxh5bwv_7eff5f4a-ca61-403e-8872-13e616f50a3d.png",
  kitchen: "https://images.pexels.com/photos/7166942/pexels-photo-7166942.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1000",
  flatlay: "https://images.pexels.com/photos/8903276/pexels-photo-8903276.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
};

export const LOGO =
  "https://customer-assets.emergentagent.com/job_discount-retail-hub-1/artifacts/iaj5zwud_logo%20%283%29.png";

export const FEATURES = [
  {
    title: "Trusted Brands",
    text: "Quality products from recognized manufacturers.",
    icon: "BadgeCheck",
  },
  {
    title: "Exceptional Value",
    text: "Save significantly compared to retail.",
    icon: "Tag",
  },
  {
    title: "Fresh Inventory",
    text: "New arrivals every week.",
    icon: "Sparkles",
  },
];

export const HIGHLIGHTS = [
  { title: "Trusted Brands", text: "Recognizable national brands", icon: "BadgeCheck", accent: "#F8B808", href: "#overview" },
  { title: "Fresh Inventory", text: "New arrivals every week", icon: "PackagePlus", accent: "#2B8A3E", href: "#categories" },
  { title: "Big Savings", text: "Up to 70% below retail", icon: "Tag", accent: "#E8590C", href: "#categories" },
  { title: "Home & Electronics", text: "Everyday home & tech", icon: "Home", accent: "#1C7ED6", href: "#categories" },
];

export const STEPS = [
  {
    title: "Source Inventory",
    text: "Surplus inventory and customer returns from major retailers.",
    icon: "PackageSearch",
  },
  {
    title: "Inspect & Sort",
    text: (
      <>
        Products are reviewed, organized
        <br className="hidden lg:block" /> and prepared for resale.
      </>
    ),
    icon: "ClipboardCheck",
  },
  {
    title: "Merchandise",
    text: (
      <>
        Items are displayed in-store
        <br className="hidden lg:block" /> for customers.
      </>
    ),
    icon: "Store",
  },
  {
    title: "Sell & Restock",
    text: (
      <>
        Inventory moves quickly and
        <br className="hidden lg:block" /> is refreshed regularly.
      </>
    ),
    icon: "RefreshCw",
  },
];

export const FEATURED_DEALS = [
  { title: "Tramontina 4-Piece Stainless Steel Fry Pan Set", category: "Kitchen", rating: 4, reviews: 61, save: "Save up to 21%", originalPrice: "$69.99", price: "$54.99", savings: "Save $15", image: "/deals/tramontina-frypan-set.png", description: "Durable tri-ply stainless steel fry pans built for even heating and everyday performance in the kitchen." },
  { title: "Ninja Crispi 5-in-1 Portable Glass Air Fry Cooking System", category: "Appliances", rating: 5, reviews: "1,929", save: "Save up to 25%", originalPrice: "$159.99", price: "$119.99", savings: "Save $40", image: "/deals/ninja-crispi.png", description: "A portable 5-in-1 glass air fry system for cooking, crisping and storing meals with less oil." },
  { title: "SHOKZ OpenFit 2 SE Open-Ear Wireless Earbuds", category: "Electronics", rating: 4, reviews: 20, save: "Save up to 25%", originalPrice: "$162.99", price: "$122.99", savings: "Save $40", image: "/deals/shokz-openfit.png", description: "Open-ear wireless earbuds delivering rich sound and all-day comfort while keeping you aware of your surroundings." },
  { title: "Cordless Stick Vacuum Cleaner", category: "Home Essentials", rating: 4, reviews: "4,917", save: "Save up to 20%", originalPrice: "$599.99", price: "$479.99", savings: "Save $120", image: "/deals/cordless-vacuum.png", description: "A powerful cordless stick vacuum with strong suction and easy manoeuvrability for quick, thorough cleaning." },
  { title: "Anchor Hocking TrueSeal 16-Piece Glass Food Storage Set", category: "Kitchen", rating: 4, reviews: "1,001", save: "Save up to 23%", originalPrice: "$21.99", price: "$16.99", savings: "Save $5", image: "/deals/anchor-hocking-glass-set.png", description: "A 16-piece glass food storage set with airtight TrueSeal lids, ideal for prepping, storing and reheating meals." },
  { title: "Ovente Smokeless Griddle & Grill System", category: "Appliances", rating: 4, reviews: 88, save: "Save up to 22%", originalPrice: "$89.99", price: "$69.99", savings: "Save $20", image: "/deals/ovente-smokeless-grill.png", description: "An indoor smokeless griddle and grill system for searing steaks, veggies and more with easy cleanup." },
  { title: "Roborock QX Revo PLUS Robot Vacuum and Mop with Multifunctional Dock 3.0", category: "Home Essentials", rating: 4, reviews: 446, save: "Save up to 21%", originalPrice: "$479.99", price: "$379.99", savings: "Save $100", image: "/deals/roborock-qx-revo-plus.png", description: "A powerful robot vacuum and mop with a multifunctional self-emptying and self-cleaning dock for hands-free cleaning." },
  { title: "Turkish Towels Optimum Towel Sets", category: "Home Essentials", rating: 4, reviews: 1108, save: "Save up to 21%", originalPrice: "$94.99", price: "$74.99", savings: "Save $20", image: "/deals/turkish-towels.png", description: "Plush, highly absorbent Turkish cotton towel sets that stay soft wash after wash." },
  { title: "HP OmniBook 5 16\" Touchscreen Laptop – AMD Ryzen AI 9 465", category: "Electronics", rating: 3, reviews: 16, save: "Save up to 21%", originalPrice: "$1,649.99", price: "$1,299.99", savings: "Save $350", image: "/deals/hp-omnibook-5.png", description: "A 16-inch touchscreen Copilot+ PC powered by AMD Ryzen AI for fast, intelligent everyday performance." },
  { title: "Nellie's Wow Mop Starter Kit", category: "Home Essentials", rating: 4, reviews: 492, save: "Save up to 27%", originalPrice: "$199.99", price: "$145.99", savings: "Save $54", image: "/deals/nellies-wow-mop.png", description: "A cordless powered mop starter kit with reusable pads and cleaning solution for effortless floor care." },
];

export const CATEGORIES = [
  {
    title: "Household Goods",
    desc: "Kitchenware,|cookware & storage",
    bg: "#FBF5E6",
    image:
      "https://customer-assets.emergentagent.com/job_discount-retail-hub-1/artifacts/rel6qosx_18cade03-acbf-4cff-9921-0919c0054926.png",
  },
  {
    title: "Electronics",
    desc: "Everyday tech|& accessories",
    bg: "#EDF3FB",
    image:
      "https://customer-assets.emergentagent.com/job_discount-retail-hub-1/artifacts/zpp3lg49_959f51fc-02ba-49b5-9966-15bcbe3825bb.png",
  },
  {
    title: "Small Appliances",
    desc: "Coffee makers,|kettles & toasters",
    bg: "#F1F0F6",
    image:
      "https://customer-assets.emergentagent.com/job_discount-retail-hub-1/artifacts/fbetimsi_0615c86f-ee73-4ded-af64-a07ab288536c.png",
  },
  {
    title: "Home Essentials",
    desc: "Cleaning & daily|needs",
    bg: "#EDF5EE",
    image:
      "https://customer-assets.emergentagent.com/job_discount-retail-hub-1/artifacts/swjde53z_4745bb23-b550-45a0-b375-83d9cc9f1653.png",
  },
];

export const WHY = [
  { title: "Brand-Name Products", text: "Trusted national brands", icon: "ShieldCheck" },
  { title: "Great Savings", text: "Below traditional retail prices", icon: "PiggyBank" },
  { title: "Ever-Changing Selection", text: "New products every visit", icon: "Repeat" },
  { title: "Local Shopping Experience", text: "Friendly, community-focused", icon: "MapPin" },
];

export const BUSINESS = [
  { title: "Established Brand", icon: "Award" },
  { title: "Operational Guidance", icon: "Compass" },
  { title: "Supplier Introductions", icon: "Handshake" },
  { title: "Launch Support", icon: "Rocket" },
  { title: "Ongoing Advisory Support", icon: "LifeBuoy" },
  { title: "Scalable Growth Potential", icon: "TrendingUp" },
];

export const FRANCHISE_ITEMS = [
  { title: "Brand Identity", icon: "Palette" },
  { title: "Store Setup", icon: "LayoutGrid" },
  { title: "Supplier Network", icon: "Network" },
  { title: "Operating Guide", icon: "BookOpen" },
  { title: "Launch Support", icon: "Rocket" },
  { title: "Ongoing Support", icon: "Headphones" },
];

export const FRANCHISE_WHY = [
  {
    title: "Proven Retail Model",
    text: "A simple, value-driven format built around strong, recurring consumer demand.",
    icon: "Store",
  },
  {
    title: "Trusted Brand Products",
    text: "Source recognizable national brands at prices that keep customers coming back.",
    icon: "BadgeCheck",
  },
  {
    title: "Ongoing Support",
    text: "Operational guidance, supplier introductions and support at every stage.",
    icon: "LifeBuoy",
  },
];

export const FRANCHISE_INCLUDED = [
  { title: "Brand Identity", text: "Logo, signage and store branding guidelines.", icon: "Palette" },
  { title: "Store Setup", text: "Layout, fixtures and merchandising direction.", icon: "LayoutGrid" },
  { title: "Supplier Network", text: "Access to established sourcing relationships.", icon: "Network" },
  { title: "Operating Guide", text: "Day-to-day playbook for running your location.", icon: "BookOpen" },
  { title: "Launch Support", text: "Hands-on help preparing for your opening.", icon: "Rocket" },
  { title: "Ongoing Support", text: "Continued advisory support as you grow.", icon: "Headphones" },
];

export const FRANCHISE_INVESTMENT = [
  { item: "Brand & Concept Fee", detail: "Contact us" },
  { item: "Initial Investment", detail: "Based on location & store size" },
  { item: "Launch Timeline", detail: "Typically 8–12 weeks" },
  { item: "Ongoing Support", detail: "Included" },
];

export const FACTS = [
  { value: "Trusted", label: "Brand Names", detail: "Recognizable national brands across every category." },
  { value: "Up to 70%", label: "Below Retail", detail: "Significant savings compared to traditional retail pricing." },
  { value: "Fresh", label: "Weekly Arrivals", detail: "New inventory arrives regularly for a fresh selection." },
  { value: "100%", label: "Inspected", detail: "Every item is reviewed and sorted before resale." },
  { value: "1000s", label: "Of Products", detail: "Household goods, electronics, appliances and essentials." },
  { value: "Canada", label: "Wide", detail: "Serving value-conscious shoppers across the country." },
];

export const FAQS = [
  {
    q: "What products does Home Cart sell?",
    a: "Home Cart offers a wide range of quality household products, electronics, small appliances, furniture, décor, seasonal items and everyday essentials from trusted, well-known brands.",
  },
  {
    q: "Where does inventory come from?",
    a: "Our inventory is sourced from Costco overstock, stock overruns and customer returns acquired from major retailers, allowing us to pass significant savings on to our shoppers.",
  },
  {
    q: "Are products new?",
    a: "Most items are new overstock or stock overruns. Customer returns are carefully reviewed, organized and prepared for resale before being placed on the sales floor.",
  },
  {
    q: "How often does inventory change?",
    a: "New products arrive regularly. Because inventory moves quickly and is restocked frequently, every visit offers a fresh and unique shopping experience.",
  },
  {
    q: "Can I learn more about opening a Home Cart location?",
    a: "Yes. Qualified operators can request information about launching a Home Cart location using our established systems, supplier relationships and operational guidance.",
  },
  {
    q: "How do I contact Home Cart?",
    a: "Simply fill out the Request Information form on this page and our team will be happy to answer your questions and tell you more about Home Cart.",
  },
];

export const PROVINCES = [
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Nova Scotia",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Northwest Territories",
  "Nunavut",
  "Yukon",
];
